import { Budget, Expense } from "@/types/budget";

export const mockExpenses: Expense[] = [
  {
    id: '1',
    date: '2024-05-15',
    category: 'Food & Beverages',
    vendor: 'Gourmet Catering Co.',
    amount: 3500,
    description: 'Deposit for conference lunch buffet',
    paymentMethod: 'credit',
    status: 'approved',
    taxAmount: 280,
    tags: ['catering', 'deposit'],
    createdAt: '2024-03-10T08:00:00Z',
    updatedAt: '2024-03-10T08:00:00Z',
  },
  {
    id: '2',
    date: '2024-05-20',
    category: 'Equipment',
    vendor: 'AudioVision Systems',
    amount: 2800,
    description: 'Sound system rental and setup',
    paymentMethod: 'check',
    status: 'pending',
    taxAmount: 224,
    tags: ['tech', 'rental'],
    createdAt: '2024-03-11T09:15:00Z',
    updatedAt: '2024-03-11T09:15:00Z',
  },
  {
    id: '3',
    date: '2024-05-25',
    category: 'Marketing',
    vendor: 'Digital Print Solutions',
    amount: 1200,
    description: 'Conference brochures and banners',
    paymentMethod: 'credit',
    status: 'approved',
    taxAmount: 96,
    tags: ['printing', 'marketing'],
    createdAt: '2024-03-12T14:30:00Z',
    updatedAt: '2024-03-12T14:30:00Z',
  },
  {
    id: '4',
    date: '2024-05-28',
    category: 'Decorations',
    vendor: 'EventSpace Designs',
    amount: 1500,
    description: 'Stage and hall decorations',
    paymentMethod: 'credit',
    status: 'rejected',
    taxAmount: 120,
    tags: ['decor'],
    createdAt: '2024-03-13T11:45:00Z',
    updatedAt: '2024-03-13T11:45:00Z',
  },
];

export const mockBudget: Budget = {
  id: '1',
  eventName: 'Annual Company Conference 2024',
  totalAmount: 50000,
  allocations: {
    'Food & Beverages': 15000,
    'Decorations': 5000,
    'Equipment': 10000,
    'Rentals': 12000,
    'Marketing': 5000,
    'Entertainment': 3000,
  },
  expenses: mockExpenses,
  startDate: '2024-06-01',
  endDate: '2024-06-03',
};